import { ChevronLeft } from 'lucide-react';

interface MobileHeaderProps {
  title: string;
  canGoBack: boolean;
  onBack: () => void;
  rightActions?: React.ReactNode;
}

export function MobileHeader({ title, canGoBack, onBack, rightActions }: MobileHeaderProps) {
  return (
    <div
      className="flex items-center border-b shrink-0"
      style={{
        height: 48,
        backgroundColor: 'var(--dbgo-panel)',
        borderColor: 'var(--border-default)',
      }}
    >
      {/* Back button area */}
      <div className="w-12 flex items-center justify-center">
        {canGoBack && (
          <button
            onClick={onBack}
            className="flex items-center justify-center text-accent-blue"
            style={{ width: 44, height: 44 }}
          >
            <ChevronLeft size={24} />
          </button>
        )}
      </div>

      {/* Title */}
      <div className="flex-1 text-center text-sm font-semibold text-text-primary truncate px-2">
        {title}
      </div>

      {/* Right actions area */}
      <div className="w-12 flex items-center justify-center">
        {rightActions}
      </div>
    </div>
  );
}
